import api from '..'

const downloadMonitoringTemplate = (
  file: 'import_participants',
  courseID: number
) => {
  return api.get<Blob>(
    `/imports/${file}/download_template?course_id=${courseID}`,
    {
      responseType: 'blob',
    }
  )
}

export default downloadMonitoringTemplate
